// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main-tabs[data-v-b44c7e24] {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.content-wrapper[data-v-b44c7e24] {
  flex: 1;
  overflow-y: auto;
}
[data-v-b44c7e24] .van-tabbar-item__icon img {
  height: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
